import { render, staticRenderFns } from "./caixasMesas.vue?vue&type=template&id=5cbed940&"
import script from "./caixasMesas.vue?vue&type=script&lang=js&"
export * from "./caixasMesas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports